import appParameters from '../../utils/AppParameters';
import modeType from '../../../constants/ModeConstants';
import properties from '../../../constants/Properties';
import storeManager from '../../../store/StoreManager';
import platformDetection from '../../utils/PlatformDetection';
import audioEditorUtils from '../../audioEditor/utils/AudioEditorUtils';

const audioToolUtils = {
    totalTime: -1,
    trackWidth: -1,
    audioPlayerKeyboardShortcutAction: undefined,

    isAudioTool() {
        if (appParameters.context == modeType.AUDIO_TOOL || appParameters.context == modeType.AUDIO_TOOL_PLAYER)
            return true;
        else
            return false;
    },
    isAudioEditorTool() {
        if (appParameters.context == modeType.AUDIO_TOOL)
            return true;
        else
            return false;
    },
    isAudioPlayer() {
        if (appParameters.context == modeType.AUDIO_TOOL_PLAYER)
            return true;
        else
            return false;
    },
    getTimelineComponentTopOffset() {
        const listHeight = properties.SLIDE_VIEWER_TOP_GAP * 5;
        const normalSlideViewerHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + properties.SLIDE_VIEWER_BOTTOM_GAP;

        return normalSlideViewerHeight + properties.SLIDE_VIEWER_TOP_GAP;
    },
    buttonsHolderWidth() {
        if (this.isAudioTool()) {
            var value = storeManager.getState().menu.buttonsHolderWidth;

            if (value >= 0)
                return value;
            else {
                if (platformDetection.isIOS())
                    return properties.BUTTONS_HOLDER_COLLAPSED_WIDTH;
                else
                    return properties.BUTTONS_HOLDER_WIDTH;
            }
        } else
            return properties.BUTTONS_HOLDER_WIDTH;
    },
    isLeftSideCollapsed() {
        const state = storeManager.getState();
        const buttonsHolderWidth = state.menu.buttonsHolderWidth;

        if (!(buttonsHolderWidth > 0) && platformDetection.isIOS() && this.isAudioTool())
            return true;

        if (buttonsHolderWidth == properties.BUTTONS_HOLDER_COLLAPSED_WIDTH)
            return true;
        else
            return false;
    },
    headerHeight() {
        if (platformDetection.isIOSApp())
            return properties.HEADER_HEIGHT_APP;
        else
            return properties.HEADER_HEIGHT;
    },
    timelineHeight() {
        if (this.isAudioTool())
            return properties.AUDIO_TIMELINE_BIG_HEIGHT;
        else
            return properties.AUDIO_TIMELINE_HEIGHT;
    },
    checkTotalTime(trackWidth) {
        if (this.totalTime < 0)
            this.totalTime = audioEditorUtils.getTimelinesMaxPosition();

        if (this.trackWidth < 0)
            this.trackWidth = trackWidth;
    },
    getCurrentTime(markerPosition, addMilliseconds = true) {
        if (markerPosition > 0) {
            var text = '';

            var totalSeconds = parseInt(markerPosition);
            var minutes = Math.floor(totalSeconds / 60);
            var seconds = totalSeconds - minutes * 60;
            var miliseconds = markerPosition - totalSeconds;
            var endValue = addMilliseconds ? ':' : '';

            miliseconds = Math.floor(miliseconds * 100);

            if (minutes < 10)
                text = text + '0' + minutes + ':';
            else
                text = text + minutes + ':';

            if (seconds < 10)
                text = text + '0' + seconds + endValue;
            else
                text = text + seconds + endValue;

            if (addMilliseconds) {
                if (miliseconds < 10)
                    text = text + '0' + miliseconds;
                else
                    text = text + miliseconds;
            }

            return text;
        } else {
            if (addMilliseconds)
                return '00:00:00';
            else
                return '00:00';
        }
    },
    getTotalTime() {
        return this.getCurrentTime(this.totalTime);
    },
    getMarkerPosition(markerPosition) {
        return (this.trackWidth * markerPosition) /  this.totalTime;
    },
    getMarkerTime(markerPosition) {
        return (this.totalTime * markerPosition) /  this.trackWidth;
    },
    getGraphControlPointSize() {
        if (platformDetection.isIOS())
            return properties.AUDIO_CONTROL_POINT_SIZE_IOS;
        else
            return properties.AUDIO_CONTROL_POINT_SIZE;
    },
    getGraphControlLineSize() {
        if (platformDetection.isIOS())
            return properties.LINE_HOLDER_HEIGHT_IOS;
        else
            return properties.LINE_HOLDER_HEIGHT;
    }
};

export default audioToolUtils;



/** WEBPACK FOOTER **
 ** ./src/components/audioTool/utils/AudioToolUtils.js
 **/